export const environment = {
  production: false,
  baseUrl: 'https://devtransportationapi.edship.in/',
  apiUrl: 'https://devtransportationapi.edship.in/api/',
  imgUrl: 'https://devtransportationapi.edship.in',
  feeServiceBaseUrl: 'https://devtransportationapi.edship.in/api/',
  libraryManagementBaseUrl: 'https://devtransportationlibrary.edship.in/api/',
  hrmsBaseUrl: 'https://devtransportationhrms.edship.in',
  assetApiUrl: 'https://devtransportationasset.edship.in/api/',
  assetBaseUrl: 'https://devtransportationasset.edship.in/',
  googleApiKey: 'AIzaSyCWcIRP_ueh_l6mHu6FzbI8WdfRO5txEt8',
  mapboxToken: 'pk.eyJ1IjoiZWRzaGlwLXRlY2hub2xvZ2llcyIsImEiOiJjbW80ODV3ZGUwdTQ5MnhzZXJ3cWhuamgwIn0.X0fCoDrtFGXhEPfY8LgSiA',
  gdsBaseUrl: 'https://gds.edship.in/api/',
  eStoreBaseUrl: 'https://estoreapi.edship.in/api/',
  useMockData: false,
  misApiUrl: 'https://devtransportationapi.edship.in/api/',
  governanceApiUrl: 'https://devtransportationapi.edship.in/api/',
};
